import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { ScrollFadeContainer } from "src/ui/style";

export const Article = styled.div``;
export const ArticleItem = styled.div``;
export const ArticleCategory = styled.p``;
export const ArticleValue = styled.p``;

export const ArticleList = styled(ScrollFadeContainer)`
	${css`
		${Article} {
			display: grid;
			gap: 10px;
			padding: 12px 24px;

			:not(:last-child) {
				border-bottom: 1px solid #b6b6b6;
			}
		}

		${ArticleItem} {
			display: grid;
			grid-template-columns: 100px auto;
		}

		${ArticleCategory}, ${ArticleValue} {
			margin: 0;
		}
		${ArticleCategory} {
			color: #8a8a8a;
			overflow-wrap: break-word;
		}
		${ArticleValue} {
			font-weight: 400;
		}
	`}
`;
